module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/15-18eac9c30c91eaf54c40f66c5f147b14.jpg";